import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
// Import the Logo here so it can be rendered globally
import Logo from "./Rijschool2.png"; // Adjust path if Rijschool.png is not in the same directory as App.js

// Import all your page components
import FeedbackOverview from "./components/FeedbackOverview";
import AdminLogin from "./components/AdminLogin";
import Homepage from "./components/Homepage";
import Reservation from "./components/Reservation";
import EditFeedbackForm from "./components/EditFeedbackForm";
import QuestionForm from "./components/QuestionForm";
import Check from "./components/check";
import Datepicker from "./components/DatePicker";
import Appointments from "./components/appointments";
// import Instellingen from "./components/instellingen";
import AdminAppointments from "./components/AdminAppointments";
import Register from "./components/Register";
import AboutUs from "./components/AboutUs";
import Pricing from "./components/Pricing";

function App() {
  return (
    <Router>
      {/* The logo is placed here, outside of the Routes, so it appears on all pages. */}
      {/* It will be positioned according to the .logo class in your App.css. */}
      <img src={Logo} alt="PlanSucces Logo" className="logo" />

      {/* You can also place the Home link here if you want it on all pages */}
      {/* <Link to="/" className="home-link">Home</Link> */}

      <Routes>
        <Route path="/" element={<Homepage />} />
        <Route path="/overview" element={<FeedbackOverview />} />
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/register" element={<Register />} />
        <Route path="/reservation" element={<Reservation />} />
        <Route path="/edit" element={<EditFeedbackForm />} />
        <Route path="/form" element={<QuestionForm />} />
        <Route path="/check" element={<Check />} />
        <Route path="/Datepicker" element={<Datepicker />} />
        {/* <Route path="/instellingen" element={<Instellingen />} /> */}
        <Route path="/appointments" element={<Appointments />} />
        <Route path="/adminappointments" element={<AdminAppointments />} />
        <Route path="/about" element={<AboutUs />} />
        <Route path="/pricing" element={<Pricing />} />
      </Routes>
    </Router>
  );
}

export default App;
